import $ from 'jQuery';

const { jakte } = window;

// DOM elements
let form;
let sendButton;
let captureLeadSuccess;
let captureLeadError;

// Logic
/// Acquires DOM elements, chooses an agency, and attaches the submit form handler to the submit event.
function init() {
  sendButton = $('.Contact--send');
  captureLeadSuccess = $('.Contact--success');
  captureLeadError = $('.Contact--error');

  form = $('.js-form-submit');
  if (form[0]) {
    form.on('submit', handleSubmitForm);
  }
  else {
    console.warn('A contact form with id \'.js-form-submit\' must be present in the DOM');
  }
}

/// Displays the contact for error state if the lead capture fails
/// Throws the error so that sentry can capture it.
function _captureLeadError(error) {
  console.error(error);
  captureLeadError.show(0);
  throw error;
}

/// Resets the contact form and toggles the "Send" button after the contact email was sent successfully.
function _captureLeadSuccess() {
  captureLeadError.hide(0);
  sendButton.hide(0);
  captureLeadSuccess.show(0);
  form[0].reset();
}

/// Creates the email message from the form fields and sends the email.
function handleSubmitForm() {
  const firstName    = form[0]['firstname'].value;
  const lastName = form[0]['lastname'].value;
  const email   = form[0]['email'].value;
  const phone   = form[0]['phone'].value;
  const message = form[0]['message'].value;

  /* Data as it will be sent to jakte.
   * See the spec here: https://github.com/Drawbotics/jakte/tree/dev/packages/jakte-plugin-leads
   * If a field present in the contact form is not supported by jakte, concatenate it to the
   * `message` value
   */
  const data = {
    firstName,
    lastName,
    email,
    phone,
    message,
  };
  
  jakte.Jakte.plugins.leads.captureLead(data).then(_captureLeadSuccess).catch(_captureLeadError);
}

export default {
  init,
};



// WEBPACK FOOTER //
// ./src/static/js/modules/submit-form.js